<template>
  <div>
    <el-button type="text" @click="openBatchAdd">
      <i class="el-icon el-icon-plus"></i>
      {{ btnName }}
    </el-button>

    <el-dialog destroy-on-close width="40%" :visible.sync="batchAddOpen">
      <template slot="title">
        <div class="dialog-title">批量添加</div>
      </template>
      <el-form-item :label="label" label-width="120">
        <el-input v-model="batchValue" type="textarea" :autosize="{ minRows: 4, maxRows: 6 }" :placeholder="placeholder"></el-input>
      </el-form-item>
      <div slot="footer" class="footer-btns">
        <el-button @click="batchAddOpen = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    btnName: { type: String, default: '批量添加' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '请输入内容，用中/英文逗号隔开' }
  },
  data() {
    return {
      batchValue: '',
      batchAddOpen: false
    }
  },
  methods: {
    openBatchAdd() {
      this.batchValue = ''
      this.batchAddOpen = true
    },
    handleSave() {
      this.$emit('save-add', this.batchValue)
    }
  }
}
</script>

<style lang="stylus" scoped>
.dialog-title
  border-bottom 1px solid #eee
.footer-btns
  text-align center
  .el-button
    margin-right 20px
</style>
